const kbArticles = {
  aiImages: 'https://describely.notion.site/Create-AI-Images-Using-Art-Studio-1252005a5b22478aaaaa98729a7bdd17?pvs=25',
  rolloverCredits: 'https://describely.notion.site/Copysmith-Help-Center-b0c792cf63a64cc7bc5d1fb07648ff1c',
};

export default kbArticles;
